import React from 'react'
import { Header2 } from '../utils/Header'

import Label from '../utils/Label'
import Input from '../utils/Input'

const EnterAmount = ({ onChange, defaultValue, standalone = true }) => {
  return (
    <div className="">
      {standalone && (
        <>
          <Header2>Thank You WanderingLabs</Header2>
          <p className="text-lg">Reach out with any questions or comments: info@wanderinglabs.com</p>
          <div className="mt-6"></div>
        </>
      )}
      <Label>Amount:</Label>
      <div className="w-24">
        <label className="inline-flex text-2xl align-top">
          <div className="leading-loose border border-r-0 rounded-l pl-2 border-gray-300 bg-white">$</div>
          <Input onChange={e => onChange(parseInt(e.target.value || 0))} defaultValue={defaultValue} leadingOpen />
        </label>
      </div>
      <div className=""></div>
    </div>
  )
}

export default EnterAmount
